import { render, staticRenderFns } from "./recommended-accommodation.vue?vue&type=template&id=2e9510be&scoped=true&"
import script from "./recommended-accommodation.vue?vue&type=script&lang=js&"
export * from "./recommended-accommodation.vue?vue&type=script&lang=js&"
import style0 from "./recommended-accommodation.vue?vue&type=style&index=0&id=2e9510be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9510be",
  null
  
)

export default component.exports